import React, { useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { SigningFontModal } from './SigningFontModal.tsx';
import { BrokerClientApi } from '@apply/api';
import { applicationInsights } from '../../ApplicationInsights';

const brokerClientApi = new BrokerClientApi.BrokerClientApi(applicationInsights);

export const ESignModal = ({ isOpen, confirmCallback, cancelCallback, signatureText, agreementHtml }) => {
    const [openSigningFontModal, set_openSigningFontModal] = React.useState(false);
    const [agreeDisabled, set_agreeDisabled] = React.useState(true);
    const [readAgreemnent, set_readAgreemnent] = React.useState(true);
    const [signatureFont, set_signatureFont] = React.useState(undefined);
    const [ipAddress, set_ipAddress] = React.useState();
    const dialogRef = React.useCallback((dialog) => {
        // if (!dialog) return;
        // const height = dialog.scrollHeight;
        // const offsetHeigt = dialog.offsetHeight + 50;
        // const isBottom = height - offsetHeigt <= dialog.scrollTop;
        set_readAgreemnent(true);
    }, []);

    useEffect(() => {
        _getIpAddress();
    }, []);

    useEffect(() => {
        window.addEventListener('resize', scrollToTheBottom);
    });

    const _getIpAddress = async () => {
        try {
            const response = await brokerClientApi.getIpAddress();
            if (response.statusCode !== 200) return;
            set_ipAddress(response.result);
        } catch {
            return;
        }
    };

    const _handleConfirm = () => confirmCallback(signatureFont);
    const _handleCancel = () => {
        cancelCallback();
    };

    const _onClickToSign = (event) => {
        event.preventDefault();

        set_openSigningFontModal(true);
    };

    const _handSigningConfirm = (font) => {
        if (font) set_agreeDisabled(false);

        set_signatureFont(font);
        set_openSigningFontModal(false);
    };

    const _handleSigningCancel = () => {
        set_openSigningFontModal(false);
    };

    const styles = {
        flexboxContainer: {
            display: 'flex',
            justifyContent: 'center',
        },
        signatureContainer: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
        },
        buttonDiv: {
            paddingTop: 20,
            paddingRight: 10,
            paddingBottom: 0,
            paddingLeft: 10,
        },
        button: {
            width: 175,
        },
        signButton: {
            margin: 0,
        },
        noPadding: {
            padding: 0,
        },
    };

    const scrollToTheBottom = (e) => {
        // if (!isOpen) return;
        // const element = document.getElementById('alert-dialog-content');
        // if (!element) return;
        // const height = element.scrollHeight;
        // const offsetHeigt = element.offsetHeight + 30;
        // const isBottom = height - offsetHeigt <= element.scrollTop;
        set_readAgreemnent(true);
    };

    return (
        <div>
            <Dialog
                open={isOpen}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
                maxWidth='lg'
            >
                <DialogContent
                    id='alert-dialog-content'
                    onScroll={scrollToTheBottom}
                    ref={dialogRef}
                >
                    <DialogContentText
                        id='alert-dialog-description'
                        className='eSignModal'
                        dangerouslySetInnerHTML={{ __html: agreementHtml }}
                    ></DialogContentText>
                </DialogContent>
                <DialogActions>
                    <div className='modal-content modal-content--esign'>
                        <div className='modal-body'>
                            <div
                                className='standard-form'
                                style={styles.noPadding}
                            >
                                <div style={styles.flexboxContainer}>
                                    <div style={styles.signatureContainer}>
                                        <div>
                                            <label>
                                                <strong>Signed by:</strong>
                                            </label>
                                        </div>
                                        <div
                                            style={{
                                                marginTop: 10,
                                                marginBottom: 10,
                                            }}
                                        >
                                            {signatureFont ? (
                                                <div
                                                    style={{
                                                        fontSize: 24,
                                                        fontFamily: signatureFont.name,
                                                    }}
                                                >
                                                    {signatureText}
                                                </div>
                                            ) : (
                                                <button
                                                    type='button'
                                                    className='button hollow'
                                                    style={styles.signButton}
                                                    onClick={_onClickToSign}
                                                >
                                                    Click to Sign
                                                </button>
                                            )}
                                        </div>
                                        <div>
                                            <label>
                                                <strong>{signatureText}</strong>
                                            </label>
                                        </div>
                                        <div>
                                            <label>IP Address: {!ipAddress ? 'unknown' : ipAddress}</label>
                                        </div>
                                    </div>
                                </div>
                                {/* <div
                                    style={{
                                        minHeight: '24px',
                                    }}
                                >
                                    {!readAgreemnent && (
                                        <label
                                            style={{
                                                fontStyle: 'italic',
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            Please read the agreement in full and scroll to the bottom to continue
                                        </label>
                                    )}
                                </div> */}
                                <div className='modal-content-actions'>
                                    <button
                                        type='button'
                                        className='button redButton'
                                        style={styles.button}
                                        onClick={_handleCancel}
                                    >
                                        I DO NOT ACCEPT
                                        <br />
                                        THIS AGREEMENT
                                    </button>
                                    <button
                                        type='button'
                                        className='button primary'
                                        style={styles.button}
                                        onClick={_handleConfirm}
                                        disabled={!(agreeDisabled === !readAgreemnent)}
                                    >
                                        I ACCEPT
                                        <br />
                                        THIS AGREEMENT
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </DialogActions>
            </Dialog>
            <SigningFontModal
                isOpen={openSigningFontModal}
                signatureText={signatureText}
                confirmCallback={_handSigningConfirm}
                cancelCallback={_handleSigningCancel}
                defaultSignature={true}
            />
        </div>
    );
};
